'use client'

import clsx from 'clsx'
import { ReactNode } from 'react'

import { Footer } from '@/widgets/Footer'
import { Header } from '@/widgets/Header'
import { HiddenMenu } from '@/widgets/HiddenMenu/HiddenMenu'
import { PreHeader } from '@/widgets/PreHeader'
import { SiteNotices } from '@/widgets/SiteNotices'

import { Breadcrumbs } from '@/features/breadcrumbs'

import { TPage } from '@/shared/types/deprecated-types'

import { useAppRouterPagePath } from '../../hooks/useAppRouterPagePath'
import { usePageTheme } from '../../hooks/usePageTheme'

import cl from './MainSiteLayout.module.scss'

type Props = {
	children: ReactNode
	breadcrumbs?: TPage[]
	topBanner?: ReactNode
}

export const MainSiteLayout = ({ children, breadcrumbs, topBanner }: Props) => {
	const theme = usePageTheme()
	const { showBreadCrumbs } = useAppRouterPagePath()

	const rootClasses = clsx(cl.root, {
		[cl.root__gray]: theme === 'gray',
		[cl.root__purple]: theme === 'purple'
	})

	return (
		<div className={rootClasses}>
			{topBanner}
			<PreHeader />
			<Header />
			<HiddenMenu />
			{showBreadCrumbs && <Breadcrumbs pages={breadcrumbs} />}
			<div className={cl.root__content}>{children}</div>
			<Footer />
			<SiteNotices />
		</div>
	)
}
